import {
  List,
  ListItemText,
  DialogTitle,
  Dialog,
  ListItemButton,
} from '@mui/material';

export default function ClassificationDialog({ onClose, open }) {
  const { tripClassifications } = window.config;

  function handleClose() {
    onClose(null);
  }

  const handleListItemClick = (value) => () => {
    onClose(value);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="classification-dialog-title"
      open={open}
    >
      <DialogTitle id="classification-dialog-title">
        Select classification
      </DialogTitle>
      <List>
        {tripClassifications.map((classification) => (
          <ListItemButton
            onClick={handleListItemClick(classification.value)}
            key={classification.value}
          >
            <ListItemText primary={classification.label} />
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
}
